import Footer from '@/components/Footer'
import Navigation from '@/components/Navigation'
import '@/styles/globals.css'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import localFont from "next/font/local"
import { AnimatePresence } from 'framer-motion'
import { usePathname } from 'next/navigation'
import { Analytics } from '@vercel/analytics/react';

  const inter = localFont({
    src: [
      {
        path: '../public/fonts/Inter/Inter-Thin.ttf',
        weight: "100",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-ExtraLight.ttf',
        weight: "200",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-Light.ttf',
        weight: "300",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-Regular.ttf',
        weight: "400",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-Medium.ttf',
        weight: "500",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-SemiBold.ttf',
        weight: "600",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-Bold.ttf',
        weight: "700",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-ExtraBold.ttf',
        weight: "800",
        style: "normal",
      },
      {
        path: '../public/fonts/Inter/Inter-Black.ttf',
        weight: "900",
        style: "normal",
      },
    ], 
    variable: '--font-inter',
  })

  const playfair = localFont({
    src: [
      {
        path: '../public/fonts/Playfair/PlayfairDisplay-Regular.ttf',
        weight: "400",
        style: "normal",
      },
      {
        path: '../public/fonts/Playfair/PlayfairDisplay-Medium.ttf',
        weight: "500",
        style: "normal",
      },
      {
        path: '../public/fonts/Playfair/PlayfairDisplay-SemiBold.ttf',
        weight: "600",
        style: "normal",
      },
      {
        path: '../public/fonts/Playfair/PlayfairDisplay-Bold.ttf',
        weight: "700",
        style: "normal",
      },
      {
        path: '../public/fonts/Playfair/PlayfairDisplay-ExtraBold.ttf',
        weight: "800",
        style: "normal",
      },
      {
        path: '../public/fonts/Playfair/PlayfairDisplay-Black.ttf',
        weight: "900",
        style: "normal",
      },
    ],
    variable: '--font-playfair'
  })

  const petit = localFont({
    src: [
      {
        path: '../public/fonts/Petit/PetitFormalScript-Regular.ttf',
        weight: "900",
        style: "normal",
      }
    ],
    variable: '--font-petit'
  })

export default function App({ Component, pageProps }: AppProps) {
  const router = usePathname()
  return (
    <>
      <Head>
      <meta name='viewport' content='width-device-width, initial-scale=1, viewport-fit=cover'/>
        <link rel='icon' href='/icon.png' sizes="any" />
        <link rel='icon' type="image/<generated>" href='/favicon.ico' sizes="any" />
        <link rel='apple-touch-icon' type="image/<generated>" href='/icon.png' sizes="any" />
        <meta name="robots" content="all" />
      </Head>
      <main className={`${inter.variable} ${playfair.variable} ${petit.variable} font-sans w-full min-h-screen`}>
        <AnimatePresence mode="wait">
          <Navigation />
          <Component key={router} {...pageProps} />
        </AnimatePresence>
        <Analytics />
        <Footer />

      </main>
    </>
  )
}
